import { render, staticRenderFns } from "./InternetHospital.vue?vue&type=template&id=20525620&scoped=true&"
import script from "./InternetHospital.vue?vue&type=script&lang=js&"
export * from "./InternetHospital.vue?vue&type=script&lang=js&"
import style0 from "./InternetHospital.vue?vue&type=style&index=0&id=20525620&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20525620",
  null
  
)

export default component.exports